import React, { Component } from "react";
import { NoteFormContainer } from "../containers";
import { Header } from "../components/header";
export class NoteForm extends Component {
  constructor(props) {
    super();
  }

  render() {
    return (
      <div>
        <Header />
        <div className="container">
          <NoteFormContainer deviceSerial={this.props.match.params.deviceSerial} />
        </div>
      </div>
    );
  }
}
